import isEmpty from 'lodash/isEmpty';
import React from 'react';
import PropTypes from 'prop-types';
import MeetingsCalendar from './MeetingsCalendar';
import Btn from '../buttons/Btn';
import { HelpText } from './HelpText';

export const CalendarStep = ({
  currentDate,
  currentTime,
  slideIndex,
  days,
  meetingSlots,
  onHeaderSlotClick,
  onSlotClick,
  onSlideChanged,
  toNextStep,
  timeZone,
}) => (
  <>
    <MeetingsCalendar
      dates={days}
      slots={meetingSlots[currentDate]}
      currentDate={currentDate}
      currentTime={currentTime}
      lastSlideIndex={slideIndex}
      onHeaderSlotClick={onHeaderSlotClick}
      onSlotClick={onSlotClick}
      onSlideChanged={onSlideChanged}
      timeZone={timeZone}
    />
    <Btn
      text="Je prends rendez-vous"
      name="appointment"
      block
      disabled={isEmpty(currentTime)}
      onClick={toNextStep}
    />
    <HelpText align="center">Pour des renseignements ou une inscription</HelpText>
  </>
);

CalendarStep.propTypes = {
  currentDate: PropTypes.string,
  currentTime: PropTypes.string,
  slideIndex: PropTypes.number.isRequired,
  days: PropTypes.array.isRequired,
  meetingSlots: PropTypes.object.isRequired,
  onHeaderSlotClick: PropTypes.func.isRequired,
  onSlotClick: PropTypes.func.isRequired,
  onSlideChanged: PropTypes.func.isRequired,
  toNextStep: PropTypes.func.isRequired,
  timeZone: PropTypes.string.isRequired,
};

CalendarStep.defaultProps = {
  currentDate: null,
  currentTime: null,
};
